import React from 'react';
import UserCard from '../crud/UserCard';
import QuestionMaterialCard from '../crud/QuestionMaterialCard';
import QuestionCard from '../crud/QuestionCard';
import ExamCard from '../crud/ExamCard';
import AssignmentCard from '../crud/AssignmentCard';
import SubmissionCard from '../crud/SubmissionCard';

const AdminDashboard = ({base_url}) => {
  return (
    <div className="admin-dashboard">
      <UserCard base_url={base_url}/>
      <QuestionMaterialCard base_url={base_url}/>
      <QuestionCard base_url={base_url}/>
      <ExamCard base_url={base_url}/>
      <AssignmentCard base_url={base_url}/>
      <SubmissionCard base_url={base_url}/>
    </div>
  );
};

export default AdminDashboard;